import { fetchWithToken } from "../../../api/apiutils";

export const LOT_STATUS_TYPES = ["Активный", "История", "В проекте"];

function buildParamsFromQuery(query) {
  const { filters = {}, page = 1, pageLimit = 10 } = query || {};
  const params = new URLSearchParams();

  params.set("Page", String(page));
  params.set("PageSize", String(pageLimit));

  if (filters.code && String(filters.code).trim().length > 0) {
    params.set("Code", String(filters.code).trim());
  }
  if (filters.lotStatusType) {
    console.log(filters.lotStatusType);
    params.set("LotStatusType", filters.lotStatusType);
  }

  return params;
}

export async function getLotStatuses(query) {
  const params = buildParamsFromQuery(query);

  // GET не может иметь body по спецификации fetch — передаём параметры в query string
  const res = await fetchWithToken(
    `/api/dashboard/lot-status?${params.toString()}`,
  );

  if (!res.ok) throw new Error("Не удалось получить статусы лотов");
  const data = await res.json();

  return {
    items: data?.data || [],
    total: data?.all ?? (Array.isArray(data?.data) ? data.data.length : 0),
    count: data?.count ?? 0,
  };
}

export async function changeLotStatusType({ id, lotStatusType }) {
  const res = await fetchWithToken(`/api/dashboard/lot-status/type`, {
    method: "POST",
    body: JSON.stringify({ id, lotStatusType }),
  });

  if (!res.ok) throw new Error("Не удалось изменить тип статуса");

  const message = await res.text();
  return message;
}
